import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import { VIDEO_TYPE } from "components/stories/video-studio/utils/constants";

import { Template as TemplateType } from "chq";
import TemplateTitle from "./TemplateTitle";
import VideoTemplates from "./VideoTemplates";
import ImageTemplates from "./ImageTemplates";
import MontageTemplates from "./MontageTemplates";

interface TemplatesProps {
  preview: Preview;
  templates: TemplateType[];
}

const Templates: React.FC<TemplatesProps> = ({ preview, templates }) => {
  const { data } = useContext(CreatomateContext);
  const { mediaType, montage } = data;

  if (montage) {
    return (
      <MontageTemplates preview={preview} templates={templates} />
    );
  }

  return (
    <>
      {mediaType === VIDEO_TYPE
        ? <VideoTemplates preview={preview} templates={templates} />
        : <ImageTemplates preview={preview} templates={templates} />}
    </>
  );
};

interface TemplateProps {
  preview: Preview;
  templates: TemplateType[];
}

const Template: React.FC<TemplateProps> = ({ preview, templates }) => {
  const { data } = useContext(CreatomateContext);
  const { selectedTemplate } = data;

  return (
    <>
      <TemplateTitle selectedTemplate={selectedTemplate} />
      <div className="Stories-Templates">
        <Templates preview={preview} templates={templates} />
      </div>
    </>
  );
};

export default Template;
